import React, { useEffect, useState } from 'react'
// Component
import { DivFlex } from '../../../../components/Common/CellText'
// Style Component
import { ModalWrapper, TitleModal } from './PopupHandleDocumentOutgoingStyled'
// Ant design
import { Button, Space } from 'antd'
// Mobx
import { inject, observer } from 'mobx-react'
// Other

import { ASSIGNEE_TYPE } from '../../../../constants'
import SelectPeoplePopup from '../../../../components/SelectPeoplePopup/SelectPeoplePopup'
import SelectGroupPopup from '../../../../components/SelectGroupPopup/SelectGroupPopup'
// Import ActivityHistory
import ActivityHistory from './ActivityHistory' // Thêm import ActivityHistory

const PopupHandleHistoryOutgoing = props => {
  const { internalDocumentStore, selectPeopleStore, documentCode } = props

  const {
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleCancelSelectGroup,
    clearSelected,
  } = selectPeopleStore

  const { selectedInternalDocumentIncoming } = internalDocumentStore

  const {} = selectedInternalDocumentIncoming

  const { isVisiblePopupHistoryDocument, handleCancelHistoryDocument } = props

  return (
    <ModalWrapper
      closable={false}
      footer={null}
      width={1200}
      title={
        <TitleModal>
          <span className={'title-modal'}>Lịch sử hoạt động</span>
          <Space>
            <Button
              danger
              onClick={() => {
                handleCancelHistoryDocument()
                clearSelected()
              }}>
              Đóng
            </Button>
          </Space>
        </TitleModal>
      }
      visible={isVisiblePopupHistoryDocument}>
      <ActivityHistory documentCode={documentCode} />

      <SelectPeoplePopup
        onlyOneUser={
          selectPeopleStore.assigneePopupType === ASSIGNEE_TYPE.HANDLER
        }
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
      <SelectGroupPopup
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      />
    </ModalWrapper>
  )
}

PopupHandleHistoryOutgoing.propTypes = {}

export default inject(
  'internalDocumentStore',
  'loadingAnimationStore',
  'selectPeopleStore'
)(observer(PopupHandleHistoryOutgoing))
